<template>
  <div
    class="chat-greeting"
    role="dialog"
    aria-labelledby="chat-greeting-message">
    <div class="chat-greeting__actions">
      <button
        type="button"
        :aria-label="tStatic('CaiAccessibilityCloseChatGreetingInfoText')"
        @click="close">
        <oie-use-svg
          svg="close"
          color="#000"
          width="15"
          height="15">
        </oie-use-svg>
      </button>
    </div>
    <div id="chat-greeting-message" class="chat-greeting__message">
      &#128075; {{ tStatic('caiGreetingMessage') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">

.chat-greeting {
  z-index: 2147483641;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: calc(1.25rem + 1.25rem + 3.25rem + env(safe-area-inset-bottom));;
  right: 1.25rem;
}

.chat-greeting__actions button {
  width: 1rem;
  height: 1rem;
  border: none;
  background: none;
  margin-bottom: 0.625rem;
}

.chat-greeting__message {
  background-color: #d5dbdb;
  padding: 0.75rem;
  border-radius: 0.75rem 0.75rem 0 0.75rem;
  box-shadow: 0.313rem 0.313rem 0.313rem #808080;
}

</style>
